module.exports = __webpack_public_path__ + "img/icon-gift.76c6c2de.svg";